import ReactGA from "react-ga4";
import { track } from "@vercel/analytics";

ReactGA.initialize(process.env.REACT_APP_GA_ID || "G-XXXXXXXXXX");

export const analytics = {
  addToCart: (product) => {
    ReactGA.event({ category: "Ecommerce", action: "add_to_cart", label: product.name });
    track("add_to_cart", { name: product.name, code: product.productCode, price: product.price });
  },
  beginCheckout: (cart) => {
    const total = cart.reduce((t, i) => t + i.price * i.quantity, 0);
    ReactGA.event({ category: "Ecommerce", action: "begin_checkout", value: total });
    track("begin_checkout", { items: cart.length, total });
  },
  purchaseCompleted: (order) => {
    ReactGA.event({
      category: "Ecommerce",
      action: "purchase_completed",
      label: `Order #${order.orderNumber}`,
      value: order.totalPrice,
    });
    track("purchase_completed", {
      orderNumber: order.orderNumber,
      total: order.totalPrice,
      items: order.cartItems.length,
    });
  },
};
